/**
 * Site ticket grid stage — structure-scoped, nested in the site dashboard.
 *
 * Rendered as a child route of SiteDashboardLayout, inside the shared
 * dashboard shell (which supplies AppNav + TitleBar). Lists tickets scoped
 * to the site.
 *
 * Contains:
 * - SiteTicketGridViewPage — route child component (default export)
 */
import { Box } from '@mui/material';
import React from 'react';

import LoadingScreen from '@sophocles/components/LoadingScreen';
import { useSiteDashboardLayoutContext } from '@sophocles/views/sites/SiteDashboardLayout';

import TicketGrid from './components/TicketGrid';

function SiteTicketGridViewPage() {
  // customer/selectedPlant/selectedStructure are the legacy Immutable dashboard
  // entities — TicketGrid owns a plain-id contract, so ids are resolved here
  // at the boundary rather than pushed into the child.
  const { customer, selectedStructure, selectedPlant, loading } = useSiteDashboardLayoutContext();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%' }}>
      <TicketGrid
        customerId={customer.get('id')}
        siteGroupId={selectedPlant ? selectedPlant.get('id') : null}
        siteId={selectedStructure ? selectedStructure.get('id') : null}
        persistScope="siteTicketGrid"
      />
    </Box>
  );
}

export default SiteTicketGridViewPage;
